import { Box, Toolbar } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { TransformedHeaderProps } from '../types';
import { DesktopHeaderIntersectionObserver } from './DesktopHeaderIntersectionObserver';
import { AccountMenu } from '../account-menu/AccountMenu';
import { DesktopHeaderSkeleton } from './DesktopHeaderSkeleton';
import { desktopHeaderStyles } from './styles';
import { APP_URLS } from '../../../routes/urls';
import Logo from '../../../assets/images/logo/nep.png';

export const DesktopHeader: React.FC<TransformedHeaderProps> = ({ menus, isLoading }) => {
  return isLoading ? (
    <DesktopHeaderSkeleton />
  ) : (
    <Toolbar sx={desktopHeaderStyles.toolbar} disableGutters className="container-fluid">
      <Box component={RouterLink} sx={desktopHeaderStyles.logo} to={APP_URLS.home}>
        <Box component="img" src={Logo} alt="Nepal Education Portal" />
      </Box>
      <DesktopHeaderIntersectionObserver menus={menus} />
      <Box sx={desktopHeaderStyles.accountMenuContainer}>
        <AccountMenu />
      </Box>
    </Toolbar>
  );
};
